"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logOut = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const toolkit_1 = require("@reduxjs/toolkit");
const rootNavigation_1 = require("../../navigation/rootNavigation");
const user_1 = require("../../slices/user");
const firebase_1 = require("../../auth/firebase");
exports.logOut = (0, toolkit_1.createAsyncThunk)("LOGOUT", async (_, { dispatch }) => {
    await async_storage_1.default.removeItem("authToken");
    dispatch((0, user_1.resetUser)());
    dispatch((0, user_1.createTemporaryUser)());
    (0, rootNavigation_1.navigate)('Home', { screen: 'Documents' });
    await (0, firebase_1.signOut)();
});
